import { Reveal, ChapterLabel } from "./Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-36">
    <Reveal>
      <ChapterLabel number="01" label="About" />
      <h2
        data-testid="about-title"
        className="font-display mt-6 max-w-2xl text-3xl font-light leading-tight tracking-tight text-[#1B3A5C] sm:text-4xl lg:text-5xl"
      >
        Specialist eye care, shaped by the realities of the Caribbean
      </h2>
    </Reveal>

    <div className="mt-14 grid gap-12 lg:mt-20 lg:grid-cols-[300px_1fr] lg:gap-20">
      <Reveal delay={0.15} className="lg:-mt-6">
        <div className="relative mx-auto w-fit lg:mx-0">
          <div
            className="absolute -inset-3 rounded-t-full border border-[#C9A66B]/40"
            aria-hidden="true"
          />
          <div
            className="absolute -inset-7 rounded-t-full border border-[#C9A66B]/20"
            aria-hidden="true"
          />
          <div
            data-testid="about-headshot"
            className="h-72 w-56 overflow-hidden rounded-t-full border-2 border-[#E4D2AA] bg-[#EFE8DA] lg:h-80 lg:w-64"
          >
            <img
              src={`${process.env.PUBLIC_URL}/headshot.webp`}
              alt="Dr Valence A Jordan, Consultant Ophthalmologist"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </Reveal>

      <div className="max-w-2xl space-y-6 text-base leading-relaxed text-[#4a4a4a] lg:text-lg">
        <Reveal delay={0.2}>
          <p data-testid="about-bio-1">
            I'm a consultant ophthalmologist based in Jamaica, with a clinical focus on glaucoma
            management and complex cataract surgery. I trained through a glaucoma surgery
            fellowship at Buckinghamshire Healthcare NHS Trust, and now practise at the
            University Hospital of the West Indies (UHWI) in Kingston, as well as private clinics
            in Kingston, Ocho Rios, and Montego Bay, bringing specialist eye care to patients
            across the island.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p data-testid="about-bio-2">
            My approach is shaped by a particular interest in delivering resource-appropriate,
            high-quality eye care to underserved populations across the Caribbean. Treatment
            that's effective within the realities of the settings I work in, not just in theory.
          </p>
        </Reveal>
        <Reveal delay={0.4}>
          <p data-testid="about-bio-3">
            Outside clinical care, I'm involved in teaching and training the next generation of
            ophthalmologists at UHWI.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
